enum EJoiError {
  NOT_SPACED_REGEXPS = 'NOT_SPACED_REGEXPS',
  EMPTY_REGEXPS = 'EMPTY_REGEXPS',
  EMPTY_VARIABLES = 'EMPTY_VARIABLES',
}

export {EJoiError};
